import React from 'react';
import { Crown } from 'lucide-react';
import { Button } from '../ui/button';
import { Badge } from '../ui/badge';

export const SubscriptionError = ({ error, onClose, onUpgrade }) => {
  return (
    <div className="py-8 text-center" data-testid="subscription-error">
      <div className="w-20 h-20 mx-auto rounded-full bg-gradient-to-r from-yellow-400/20 to-purple-500/20 flex items-center justify-center mb-6">
        <Crown className="w-10 h-10 text-yellow-400" />
      </div>
      <h2 className="text-2xl font-bold text-white mb-3">Upgrade to Upload</h2>
      <p className="text-gray-400 mb-6 max-w-md mx-auto">
        {error.message}
      </p>
      <div className="bg-gray-800/50 rounded-lg p-4 mb-6 max-w-sm mx-auto">
        <p className="text-sm text-gray-400 mb-2">Your current plan:</p>
        <Badge variant="outline" className="text-yellow-400 border-yellow-400/50">
          {error.currentPlan === 'free' || error.currentPlan === 'basic' 
            ? 'Basic (Free)' 
            : error.currentPlan}
        </Badge>
      </div>
      <div className="flex flex-col sm:flex-row gap-3 justify-center">
        <Button
          onClick={onClose}
          variant="outline"
          className="border-gray-600 hover:bg-gray-800 text-white"
          data-testid="subscription-error-close"
        >
          Maybe Later
        </Button>
        <Button
          onClick={onUpgrade}
          className="bg-gradient-to-r from-yellow-400 to-purple-500 hover:from-yellow-500 hover:to-purple-600 text-black font-bold"
          data-testid="subscription-error-upgrade"
        >
          View Plans & Upgrade
        </Button>
      </div>
    </div>
  );
};

export default SubscriptionError;
